import { useMemo } from 'react';
import { generateHTML } from '@tiptap/core';

import { learningSequenceTags } from 'webclient.constants';
import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import { RichtextDisplay } from './teaching-notes-drawer.style';
import { JSONObject } from 'global/graphql/scalars.type';
import AccordionToggleNew from 'approot/shared/accordion/accordion-toggle-new';

type Props = {
  data: JSONObject | null;
  title?: string;
  displayExpanded?: boolean;
};

const baseSettings = {
  placeholder: '',
  suggestions: learningSequenceTags,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
};

const TeachingNotesDetailRichtextView = ({
  data,
  title,
  displayExpanded,
}: Props) => {
  const extensions = useMemo(() => getExtensions(baseSettings), []);
  const hasRichtext = !isRichtextEmpty(data);

  return hasRichtext ? (
    <AccordionToggleNew
      title={title}
      withDividers
      displayExpanded={displayExpanded}
    >
      <RichtextDisplay
        dangerouslySetInnerHTML={{
          __html: generateHTML(data, extensions),
        }}
      />
    </AccordionToggleNew>
  ) : null;
};

export default TeachingNotesDetailRichtextView;
